









import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IBarcodeItem } from "../../../../../formatEditor/domain/editableFormat/objects";
import { IBarcodeInformationSpecification } from "../../../../../formatEditor/domain/editableFormat/IFormatSpecification";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class BarcodeItemsEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IBarcodeItem[]) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IBarcodeItem[]) => T, defaultValue: T) => T;

  @Prop()
  barcodeInformations: IBarcodeInformationSpecification[];

  @Prop()
  commonComponents: CommonComponentsContainer;

  get barcodeItems(): IBarcodeItem[] {
    return this.readPropertyOrDefault(s => s, []);
  }

  set barcodeItems(value: IBarcodeItem[]) {
    this.writePropertyWhenValid(s => s.splice(0, s.length, ...value));  // s = valueでは更新されない
  }

  async showBarcodeItemEditDialog() {
    const dialog = this.commonComponents.getDialogs().getBarcodeItemEditDialog();
    const barcodeItems = await dialog.show(this.barcodeItems, this.barcodeInformations);
    if (!barcodeItems) { return; }
    this.barcodeItems = barcodeItems;
  }
}
